module.exports = __webpack_public_path__ + "img/metrological-monitor.497b90cf.svg";